import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { firstValueFrom, from } from 'rxjs';

import { DietitianStateProvider } from '../../../../../../data/dietitian/domain/dietitian_state_provider';
import { FeatureRepository } from '../../../../../../data/dietitian/repositories/feature.repository';

@Injectable({
  providedIn: 'root',
})
export class AccountBillParamsGuard implements CanActivate {
  constructor(
    private router: Router,
    private dietitianStateProvider: DietitianStateProvider,
    private featureRepository: FeatureRepository,
  ) {
    // Nada
  }

  async canActivate(): Promise<boolean | UrlTree> {
    const feature = await firstValueFrom(
      from(this.featureRepository.findActiveByCode('billing')),
    );
    const dietitian = this.dietitianStateProvider.state.entity;
    if (dietitian) {
      if (
        dietitian.subscriptionFeatures &&
        dietitian.subscriptionFeatures[feature?.stripePriceId.id.toString()] &&
        dietitian.subscriptionFeatures[feature?.stripePriceId.id.toString()]
          .isActive
      ) {
        return true;
      }
      return this.router.createUrlTree(['/dashboard/billing-showcase']);
    } else {
      return this.router.createUrlTree(['/auth']);
    }
  }
}
